/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScanStatusCount } from './ScanStatusCount';
import {
    ScanStatusCountFromJSON,
    ScanStatusCountFromJSONTyped,
    ScanStatusCountToJSON,
} from './ScanStatusCount';
import type { HealthBucket } from './HealthBucket';
import {
    HealthBucketFromJSON,
    HealthBucketFromJSONTyped,
    HealthBucketToJSON,
} from './HealthBucket';
import type { RecentTicketScan } from './RecentTicketScan';
import {
    RecentTicketScanFromJSON,
    RecentTicketScanFromJSONTyped,
    RecentTicketScanToJSON,
} from './RecentTicketScan';
import type { ErrorMessageCount } from './ErrorMessageCount';
import {
    ErrorMessageCountFromJSON,
    ErrorMessageCountFromJSONTyped,
    ErrorMessageCountToJSON,
} from './ErrorMessageCount';

/**
 * Ticket scan outcomes across all players for a recent window, for diagnosing outages.
 * @export
 * @interface TicketScanHealth
 */
export interface TicketScanHealth {
    /**
     * Counts per time slot, oldest first, covering the whole window.
     * @type {Array<HealthBucket>}
     * @memberof TicketScanHealth
     */
    buckets: Array<HealthBucket>;
    /**
     * Length of each time slot in buckets
     * @type {number}
     * @memberof TicketScanHealth
     */
    bucketMinutes: number;
    /**
     * Newest scans first.
     * @type {Array<RecentTicketScan>}
     * @memberof TicketScanHealth
     */
    recentScans: Array<RecentTicketScan>;
    /**
     * Most frequent error messages of ERROR scans, most frequent first.
     * @type {Array<ErrorMessageCount>}
     * @memberof TicketScanHealth
     */
    errorMessages: Array<ErrorMessageCount>;
    /**
     * Share of scans with the ERROR status, from 0 to 1.
     * @type {number}
     * @memberof TicketScanHealth
     */
    errorRate: number;
    /**
     * Scans per status, most frequent first.
     * @type {Array<ScanStatusCount>}
     * @memberof TicketScanHealth
     */
    statusCounts: Array<ScanStatusCount>;
    /**
     * 
     * @type {number}
     * @memberof TicketScanHealth
     */
    total: number;
    /**
     * 
     * @type {Date}
     * @memberof TicketScanHealth
     */
    windowStart: Date;
}

/**
 * Check if a given object implements the TicketScanHealth interface.
 */
export function instanceOfTicketScanHealth(value: object): value is TicketScanHealth {
    if (!('buckets' in value) || value['buckets'] === undefined) return false;
    if (!('bucketMinutes' in value) || value['bucketMinutes'] === undefined) return false;
    if (!('recentScans' in value) || value['recentScans'] === undefined) return false;
    if (!('errorMessages' in value) || value['errorMessages'] === undefined) return false;
    if (!('errorRate' in value) || value['errorRate'] === undefined) return false;
    if (!('statusCounts' in value) || value['statusCounts'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('windowStart' in value) || value['windowStart'] === undefined) return false;
    return true;
}

export function TicketScanHealthFromJSON(json: any): TicketScanHealth {
    return TicketScanHealthFromJSONTyped(json, false);
}

export function TicketScanHealthFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketScanHealth {
    if (json == null) {
        return json;
    }
    return {
        
        'buckets': ((json['buckets'] as Array<any>).map(HealthBucketFromJSON)),
        'bucketMinutes': json['bucketMinutes'],
        'recentScans': ((json['recentScans'] as Array<any>).map(RecentTicketScanFromJSON)),
        'errorMessages': ((json['errorMessages'] as Array<any>).map(ErrorMessageCountFromJSON)),
        'errorRate': json['errorRate'],
        'statusCounts': ((json['statusCounts'] as Array<any>).map(ScanStatusCountFromJSON)),
        'total': json['total'],
        'windowStart': (new Date(json['windowStart'])),
    };
}

export function TicketScanHealthToJSON(value?: TicketScanHealth | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'buckets': ((value['buckets'] as Array<any>).map(HealthBucketToJSON)),
        'bucketMinutes': value['bucketMinutes'],
        'recentScans': ((value['recentScans'] as Array<any>).map(RecentTicketScanToJSON)),
        'errorMessages': ((value['errorMessages'] as Array<any>).map(ErrorMessageCountToJSON)),
        'errorRate': value['errorRate'],
        'statusCounts': ((value['statusCounts'] as Array<any>).map(ScanStatusCountToJSON)),
        'total': value['total'],
        'windowStart': ((value['windowStart']).toISOString()),
    };
}

